import { Navigate, useLocation, useParams } from 'react-router-dom';
import { cheminRedirige } from '../../lib/navigation/chemins';

/**
 * Une ancienne adresse qui renvoie vers la nouvelle, **en gardant** ses
 * paramètres, sa chaîne de requête et son ancre.
 *
 * Un `<Navigate to="…">` nu les perd : `/admin/factures?q=CDV-26-00012`,
 * lien que posent la fiche d'une famille et le contrôle du grand livre,
 * ouvrirait l'écran des factures sans la recherche.
 */
export default function Redirection({ vers }: { vers: string }) {
  const params = useParams();
  const { search, hash } = useLocation();
  return <Navigate to={cheminRedirige(vers, params, search, hash)} replace />;
}
